/*
 * @Description: 月度个人盈利看板
 * @Author: 杨志航
 * @Date: 2026-08-31 16:03:01
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import Main from './Main'
import NameSort from './NameSort'

const ProbationAchAudit = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/namesort'} component={NameSort} />
      <CacheRoute component={Main} />
    </CacheSwitch>
  )
}

export default ProbationAchAudit